import axios from "axios";
import config from "./config";
import { getAddInOrigin } from "../utils/addInOrigin";

const endpoint = config.GeneralBackendUrl;

export const authenticateUser = async (email, password) => {
  try {
    const response = await axios.post(
      endpoint + "auth/login",
      {
        email,
        password,
      },
      { headers: { "X-Data-Source": config.DataSource } }
    );
    return response.data; // The backend should return a token and user details
  } catch (error) {
    console.error("Login failed:", error.response || error);
    throw error;
  }
};

export const authmeUser = async (authToken) => {
  try {
    const response = await axios.get(endpoint + "auth/me", {
      headers: { Authorization: `Bearer ${authToken}`, "X-Data-Source": config.DataSource },
    });
    return response.data; // The backend should return a token and user details
  } catch (error) {
    console.error("Authme failed:", error.response || error);
    throw error;
  }
};

export const postUserTone = async (authToken, tone) => {
  try {
    const response = await axios.post(
      endpoint + "user/tone",
      {
        tone,
      },
      { headers: { Authorization: `Bearer ${authToken}`, "X-Data-Source": config.DataSource } }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to post user tone:", error);
    throw error;
  }
};

export const selectUserStyle = async (authToken, styleName) => {
  try {
    const response = await axios.post(
      endpoint + "user/select_style",
      {
        selected_style: {
          name: styleName,
        },
      },
      { headers: { Authorization: `Bearer ${authToken}`, "X-Data-Source": config.DataSource } }
    );
    return response.data;
  } catch (error) {
    // Surface backend error message if provided (e.g., style not found)
    console.error("Failed to select user style:", error?.response?.data || error);
    throw error;
  }
};

export const authenticateSSO = async (email, token, addInOrigin = getAddInOrigin()) => {
  try {
    const response = await axios.post(
      endpoint + "auth/sso",
      {
        officeToken: token,
        userEmail: email,
        addInOrigin,
      },
      { headers: { "X-Data-Source": config.DataSource } }
    );
    return response.data;
  } catch (error) {
    console.error("SSO failed:", error.response || error);
    throw error;
  }
};
